module.exports = __webpack_public_path__ + "media/images/icons/star-pink-half-fa1f99c2e32fda37725c5fc429bc3b6d.svg";